import React from "react";
import clsx from "clsx";
import fp from "lodash/fp";
import { useFormContext } from "react-hook-form";

import styles from "./warningMessage.module.scss";

export type WarningMessageProps = {
	field: string;
	errors?: any;
	warningText?: string;
	customStyles?: string | Object;
	hideWarning?: boolean;
};

export const WarningMessage: React.FC<WarningMessageProps> = ({
	field,
	errors,
	warningText,
	hideWarning,
	customStyles,
}) => {
	const formMethods = useFormContext();
	errors = errors || formMethods?.formState.errors;

	const error = () => {
		if (!errors) return null;
		if (typeof errors.message === "string") return errors;
		return fp.get(field, errors);
	};
	return !error() && !hideWarning ? (
		<div className={clsx(styles.warningMessage, customStyles)}>
			{warningText}
		</div>
	) : null;
};
